module.exports = __webpack_public_path__ + "media/images/bgjulaima1-c8eaace5a1c7feee9459111b11ac8185.jpg";